<template>
    <DefaultTemplate>
        <div class="card rounded">
            <div class="card-content text-left " :class="maxWidth > 768 ? 'pd-1':'pd-3'">
                <div v-if="tabPage == 'list' && user != null" class="columns is-vcentered disable-print flex-warp">
                    <div v-if="user.userLevel == 60" class="column is-9-desktop" :class="maxWidth > 768 ? '':'is-flex ai-end'">
                        <b-field horizontal label="ลิงค์สมัครสมาชิก:" class="copy-link is-marginless" :style="maxWidth > 768 ? '':'width:85%'">
                            <b-input :value="`${url}/signup/staff/${$route.params.formId}/${user._id}`" id="link-signup" readonly></b-input>
                        </b-field>
                        <b-button @click="copyLinkSignup()"  :style="styleObject" class=" is-hidden-desktop">คัดลอกลิงค์</b-button>
                    </div>
                    <div v-if="user.userLevel == 60" class="column pd-x-5 is-hidden-mobile">
                        <b-button @click="copyLinkSignup()"  :style="styleObject">คัดลอกลิงค์</b-button>
                    </div>
                    <div class="column is-9-desktop" :class="maxWidth > 768 ? '':'is-flex ai-end'">
                        <b-field horizontal label="ลิงค์กรอกข้อมูล:" class="copy-link is-marginless" :style="maxWidth > 768 ? '':'width:85%'">
                            <b-input :value="`${url}/form-data-list/${$route.params.formId}?token=${token}`" id="link-share" readonly></b-input>
                        </b-field>
                        <b-button @click="copyLinkShare()"  :style="styleObject" class=" is-hidden-desktop">คัดลอกลิงค์</b-button>
                    </div>
                    <div class="column pd-x-5 is-hidden-mobile">
                        <b-button @click="copyLinkShare()"  :style="styleObject">คัดลอกลิงค์</b-button>
                    </div>
                </div>
                <FormMange 
                    :tab="true" 
                    :formId="$route.params.formId"
                    :batchData="{_id:1}"
                    :demo="false"
                    :routerData="routerData"
                    :isLockForm="null"/>
            </div>
        </div>
    </DefaultTemplate>
</template>

<script>
    import DefaultTemplate from '@/template/DefaultTemplate'
    import FormMange from '@/components/form/FormMange'
    export default {
        components:{
            FormMange,
            DefaultTemplate
		},
        props: {
            routerData: {
              type: Object,
              default: null
            },
        },
        computed:{
            user(){
                return this.$store.state.user
            },
            tabPage(){
                return this.$store.state.tabPage;
            },
        },
        data() {
            return {
                decode:null,
                url:process.env.VUE_APP_URL,
                token:''
            }
        },
        mounted(){
            if(this.user != null){
                this.generateToekn()
            }
            if(typeof this.routerData.token != 'undefined' ){
                const SECRET = "00f5vdd5r12fg1g[][dsdd122"; 
                const jwt = require('jsonwebtoken'); 
                let decoded = jwt.verify(this.routerData.token, SECRET);
                console.log('decoded',decoded);  
                this.decode = decoded
                this.$store.commit('SET_TAB_PAGE',decoded.tabPage)
            }
        },
        methods: {
            generateToekn(){
                let obj = {
                    tabPage: 'detail',
                    dataId: "",
                    formName: "CEA form",
                    token: this.user.token,
                    owner: this.user._id,
                    roleId: this.user.userLevel == 60 ? this.user._id : this.$route.params.roleId,
                }

                const jwt = require('jsonwebtoken'); 
                const SECRET = "00f5vdd5r12fg1g[][dsdd122"; 
                this.token =  jwt.sign(obj, SECRET);
                console.log('generateToekn',this.token);
            },
            copyLinkSignup() {
                const copyText = document.getElementById("link-signup");
                copyText.select();
                document.execCommand("copy");
                this.$buefy.toast.open({ message: "คัดลอกลิงค์ เรียบร้อยแล้ว!", type: "is-success" ,duration:10000});
            },
            copyLinkShare() {
                const copyText = document.getElementById("link-share");
                copyText.select();
                document.execCommand("copy");
                this.$buefy.toast.open({ message: "คัดลอกลิงค์ เรียบร้อยแล้ว!", type: "is-success" ,duration:10000});
            },
        },
    }
</script>